<template>
    <v-row class="pt-2">
        <v-col cols="12" sm="4" class="py-0">
            <text-input
                v-model="contact.name"
                v-validate.immediate="'space'"
                :label="$t('labels.name')"
                :name="`${index}-name`"
                :data-vv-scope="name"
                :data-vv-as="$t('labels.name')"
                :error-messages="errors.collect(`${index}-name`, name)"
            />
        </v-col>

        <v-col cols="12" sm="4" class="py-0">
            <text-input
                v-model="contact.email"
                v-validate.immediate="'space'"
                :label="$t('labels.email')"
                :name="`${index}-email`"
                :data-vv-scope="name"
                :data-vv-as="$t('labels.email')"
                :error-messages="errors.collect(`${index}-email`, name)"
            />
        </v-col>

        <v-col cols="10" sm="3" class="py-0">
            <text-input
                v-model="contact.phone"
                v-validate.immediate="'phonenumber'"
                :label="$t('labels.phone')"
                :name="`${index}-phone`"
                :data-vv-scope="name"
                :data-vv-as="$t('labels.phone')"
                :error-messages="errors.collect(`${index}-phone`, name)"
                @blur="contact.phone = formatPhoneNumber(contact.phone)"
            />
        </v-col>

        <v-col v-if="index > 0" cols="2" sm="1" class="py-0 mt-3">
            <v-btn icon color="error" @click="$emit('remove', index)">
                <v-icon>delete</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import TextInput from '@/components/form/Inputs/TextInput'
import FormInput from '@/components/mixins/FormInput'
import PhoneNumberMixin from '@/components/mixins/PhoneNumberMixin'

export default {
    name: 'OneContact',
    components: {
        TextInput,
    },
    mixins: [FormInput, PhoneNumberMixin],
    props: {
        contact: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            errorMessages: [],
        }
    },
}
</script>
